import PageOne from "./PageOne/PageOne";
import PageTwo from "./PageTwo/PageTwo";
import PageThree from "./PageThree/PageThree";
import PageFour from "./PageFour/PageFour";
import React, { useState, useEffect } from "react";
import MultiStepProgressBar from "./MultiStepProgressBar/MultiStepProgressBar";
import Header from '../Header/Header'
import Footer from "../Footer/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { connect } from "react-redux"
// import { loginUser, apiError, socialLogin } from "../../store/actions"
import { loginSuccess  } from "../store/actions"
import { withRouter, Link } from "react-router-dom"
import PropTypes from 'prop-types'
import { post } from "../helpers/api_helper";
function Login(props) {
  const [page, setPage] = useState("pageone");
  const [loginpage, setLoginpage] = useState(false);
  const [repage, setRepage] = useState(false);
  const [registerForm, setRegisterForm] = useState(false);


const { user } = props;



  const [setpone, setStepone] = useState(null);

  useEffect(()=>{
    getStep();

  }, []);

  useEffect(()=>{
//  console.log('user on login page',user);
  }, [user]);

  const getStep=async()=>{
    var data = await localStorage.getItem("authUser");

    if(data){
      data=JSON.parse(data);
      setStepone(data?.step);
    }

  }

  const nextPage = (page) => {
    setPage(page);
  };





  const handleValidSubmit = (event, values) => {

    // console.log('values',values)
    // props.loginUser(values, props.history);
    post('/login', values)
    .then((json=>{
      // console.log('response data', json);
      if(json?.exist == false){
        if(json?.statusCode == 200){
           if(json?.message == "OTP Sent to your mailbox !"){
            localStorage.setItem('email',values.email);
            props.history.push("/register");
           }else{
             // setRepage(true);
             var opprtunity_path = localStorage.getItem('opprtunity');
             // console.log('opprtunity_path',opprtunity_path);
             if(opprtunity_path){
              props.history.push("/opportunity/"+opprtunity_path);

             }else{
              props.history.push("/");
             }
           }


        }else{
          // setRepage(false);
          // setLoginpage(true);
        // setRepage(true);
        var opprtunity_path = localStorage.getItem('opprtunity');
        // console.log('opprtunity_path',opprtunity_path);
        if(opprtunity_path){
        props.history.push("/opportunity/"+opprtunity_path);

        }else{
        props.history.push("/");
        }

        }


      }else{
        if(json?.statusCode == 200){

          // props.history.push("/login");
          setLoginpage(true);
          if(json?.message == "Password is Required!"){
             props.history.push("/login");
          }else{
            props.history.push("/");
            localStorage.setItem("authUser", JSON.stringify(json?.data));
           props?.loginSuccess(json?.data);
          }

        }

      }
    }))


  }



  return (
    <>
      <Header />

      <div className="auth-section login-section">
      <Container fluid>
         <Row className={user?.step == 1 ? 'login-box active':'login-box'}>
         <Col lg={6} md={6}>
           <AvForm
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
              }}
             >
                    <AvField type="email" name="email" label="Email" required />
                    {
                      loginpage && <AvField type="password" name="password" label="Password" required />
                    }
                    {
                      repage &&
                      <>
                       <Col lg={12}>
                    <AvField type="text" name="otp" label="Otp" required />
                    </Col>
                    <Col md={12}>
                    <AvField type="password" name="password" label="Password" required />
                    </Col>
                    <Col md={12}>
                    <AvField type="password" name="confirmpassword" label="Confirm Password" required />
                    </Col>
                      </>
                    }

                <FormGroup>
              <Button type="submit" className="common-btn">Submit</Button>
            </FormGroup>
              </AvForm>

           </Col>
           <Col lg={6} md={6} className="p-0">
                  <div className="log_in_img_box">
                 <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGN1c3RvbWVyJTIwc2VydmljZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" />
                 </div>
                </Col>
         </Row>
       </Container>
      </div>
      <Footer />
    </>
  );
}

const mapStateToProps = state => {
  const { user } = state.Login
  return { user }
}

export default withRouter(
  connect(mapStateToProps, { loginSuccess })(Login)
)


Login.propTypes = {
  history: PropTypes.object,
  loginSuccess: PropTypes.func
}